import { adminFetcher } from '@lib/fetcher'
import type {
	ShopifyBasicOrder,
	ShopifyBasicOrdersResponseType
} from '@lib/queries/orders/get-basic-orders-query'
import getBasicOrdersQuery from '@lib/queries/orders/get-basic-orders-query'

// eslint-disable-next-line import/prefer-default-export
/**
 * Normalizes order ID to numeric form. The id: prefix in the orders query explicitly
 * filters by order id only, avoiding collisions when a customer ID equals an order ID
 * (e.g. Customer/123 vs Order/123 - bare "123" would match both in a general search).
 */
function toNumericOrderId(orderId: string): string {
	return orderId.split('/').pop() ?? orderId
}

export const getBasicOrderWithTagsAndCustomAttributes = async (
	orderIds: string[]
): Promise<ShopifyBasicOrder[]> => {
	const query = orderIds.map((orderId) => `id:${toNumericOrderId(orderId)}`).join(' OR ')
	const { orders } = (await adminFetcher({
		variables: { query, numOrders: orderIds.length },
		query: getBasicOrdersQuery
	})) as ShopifyBasicOrdersResponseType

	return orders.edges.map(({ node }) => node)
}

export const getBasicShopifyOrderFront = async (
	shopifyOrderIds: string[]
): Promise<ShopifyBasicOrder[]> => {
	const encodedOrderIds = encodeURIComponent(shopifyOrderIds.join(','))
	const res = await fetch(`/api/shopify/order/list/${encodedOrderIds}`)

	const orders = await res.json()
	const shopifyBasicOrders = orders.data as ShopifyBasicOrder[]
	return shopifyBasicOrders
}
